// generator that allows for iteration through all permutations of an array
export function permute(arr) {
    var l = arr.length,
        used = Array(l),
        data = Array(l);
    return (function* backtracking(pos) {
        if (pos === l) yield data.slice();
        else
            for (var i = 0; i < l; ++i)
                if (!used[i]) {
                    used[i] = true;
                    data[pos] = arr[i];
                    yield* backtracking(pos + 1);
                    used[i] = false;
                }
    })(0);
}
